import { render, staticRenderFns } from "./ClipBoard.vue?vue&type=template&id=b10dbe84&"
import script from "./ClipBoard.vue?vue&type=script&lang=js&"
export * from "./ClipBoard.vue?vue&type=script&lang=js&"
import style0 from "./ClipBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports